import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const products = [
    {
      id: 1,
      icon: '🗺️',
      title: 'RoboMapper',
      description:
        'A compact device integrating LiDAR, vision, and IMU sensors to capture detailed environmental data. Generates high-definition 3D models for precise localization, mapping, and digital twin applications.',
      features: [
        'High-resolution 3D mapping',
        'Multi-sensor fusion',
        'Supports localization and digital twin creation',
      ],
    },
    {
      id: 2,
      icon: '📡',
      title: 'RoboMeter',
      description:
        'A plug-and-play geolocation device for GPS-denied environments such as conflict zones, underground, and indoor facilities. Available in Lite and Pro models for varying performance needs.',
      features: [
        'Reliable geolocation without GPS',
        'Operates in challenging environments',
        'Lite and Pro models for tailored performance',
      ],
    },
    {
      id: 3,
      icon: '🤖',
      title: 'iDLE',
      description:
        'An intelligent control module enabling teleoperation, semi-autonomous, and autonomous functions. Compatible with drones, wheeled, and legged platforms.',
      features: [
        'Advanced autonomy and teleoperation',
        'Multi-platform support: drones, wheeled, legged',
        'Modular integration',
      ],
    },
  ];

  return (
    <section id="solutions" className="how-it-works">
      <div className="container">
        <div className="section-title">
          <h2>Our Products</h2>
          <p>
            Precision-engineered solutions for mapping, geolocation, and intelligent autonomy in demanding environments.
          </p>
        </div>

        <div className="solutions-grid">
          {products.map((product) => (
            <div key={product.id} className="solution-card">
              <div className="solution-icon">
                <span>{product.icon}</span>
              </div>
              <h3>{product.title}</h3>
              <p>{product.description}</p>
              <ul className="solution-features">
                {product.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="technology-highlights">
          <div className="highlight-item">
            <div className="highlight-number">24/7</div>
            <div className="highlight-label">Operation</div>
          </div>
          <div className="highlight-item">
            <div className="highlight-number">99.9%</div>
            <div className="highlight-label">Reliability</div>
          </div>
          <div className="highlight-item">
            <div className="highlight-number">50%</div>
            <div className="highlight-label">Cost Reduction</div>
          </div>
          <div className="highlight-item">
            <div className="highlight-number">100%</div>
            <div className="highlight-label">Safety</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;